import gql from 'graphql-tag';

export class FormInput {
  id: number;
  collectorId: number;
  regionId: number;
  isActive: boolean;

  constructor() {
    this.id = undefined;
    this.collectorId = undefined;
    this.regionId = undefined;
    this.isActive = undefined;
  }
}

export const gqlGetCollectorsNomoiQuery = gql`
  query getCollectorsNomoi($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectorsNomoi(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        collectorId
        nomos
        collector {
          id
          name
        }
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetCollectorsRegionsQuery = gql`
  query getCollectorsRegions($limit: Int, $offset: Int, $order: String, $where: String) {
    getCollectorsRegions(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        collectorId
        collector {
          id
          name
        }
        regionId
        region {
          id
          name
        }
        isActive
        firstDate
        lastDate
        firstUser
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getCollectorsRegionById($id: Int) {
    getCollectorsRegionById(id: $id) {
      id
      collectorId
      collector {
        id
        name
      }
      regionId
      region {
        id
        name
      }
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
    }
  }
`;

export const gqlAdd = gql`
  mutation addCollectorsRegion($data: CollectorsRegionInput) {
    addCollectorsRegion(data: $data) {
      id
    }
  }
`;

export const gqlUpdateCollectorsRegions = gql`
  mutation updateCollectorsRegion($data: CollectorsRegionInput) {
    updateCollectorsRegion(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCollectorsRegion($id: Int) {
    deleteCollectorsRegion(id: $id)
  }
`;

export const gqlUpdateCollectorsNomoi = gql`
  mutation updateCollectorsNomoi($data: CollectorsNomoiInput) {
    updateCollectorsNomoi(data: $data) {
      id
    }
  }
`;

export const gqlΙnitializeCollectorsNomoi = gql`
  mutation initializeCollectorsNomoi {
    initializeCollectorsNomoi
  }
`;
